// Vue
import Vue from 'vue';
// Vuex
import Vuex from 'vuex';
import {
  Module,
  Action,
  Mutation,
  VuexModule,
  getModule
} from 'vuex-module-decorators';

// moment
import moment from 'moment';

Vue.use(Vuex);

export type RootState = LocaleState &
  ClassificationsState &
  PageCategory &
  IsHeaderDesignApply &
  LoaderStatus;
export interface LocaleState {
  locale: string;
}

export interface ClassificationsState {
  classifications: Array<Classification>;
}

export interface Classification {
  locale?: string;
  typeKindCode: string;
  types: Array<{
    code: string;
    value: string;
    logicalName: string;
    displayOrder: number;
  }>;
}

export interface PageCategory {
  pageCategory: string;
}

export interface IsHeaderDesignApply {
  isHeaderDesignApply: boolean;
}

export interface SnackBarItem {
  id: string;
  color: string;
  text: string;
  show: boolean;
}

export interface LoaderStatus {
  loader: boolean;
}

const store = new Vuex.Store<RootState>({});

// locale初期設定
moment.locale('ja');

@Module({ dynamic: true, store, name: 'StoreModule', namespaced: true })
class StoreModule extends VuexModule implements RootState {
  locale = 'ja';
  classifications: Array<Classification> = [];
  pageCategory = '';
  isHeaderDesignApply = true;
  snackBarsMap: Map<string, SnackBarItem> = new Map();
  loader = false;

  // ページ種別管理
  @Mutation
  public setPageCategory(payload: PageCategory) {
    this.pageCategory = payload.pageCategory;
  }

  public get getPageCategory(): string {
    return this.pageCategory;
  }

  // ページ種別管理
  @Mutation
  public setIsHeaderDesignApply(payload: IsHeaderDesignApply) {
    this.isHeaderDesignApply = payload.isHeaderDesignApply;
  }

  public get getIsHeaderDesignApply(): boolean {
    return this.isHeaderDesignApply;
  }

  /** SnackBar管理 */
  @Action({ commit: 'setSnackbarItem' })
  public addMessage(msg: string, color?: string): Map<string, SnackBarItem> {
    putSnackBarItem(this.snackBarsMap, msg, color || 'error');
    return new Map<string, SnackBarItem>(this.snackBarsMap);
  }
  @Action({ commit: 'setSnackbarItem' })
  public addErrorMessage(msg: string): Map<string, SnackBarItem> {
    putSnackBarItem(this.snackBarsMap, msg, 'error');
    return new Map<string, SnackBarItem>(this.snackBarsMap);
  }
  @Action({ commit: 'setSnackbarItem' })
  public addWarnMessage(msg: string): Map<string, SnackBarItem> {
    putSnackBarItem(this.snackBarsMap, msg, 'warning');
    return new Map<string, SnackBarItem>(this.snackBarsMap);
  }
  @Action({ commit: 'setSnackbarItem' })
  public addInfoMessage(msg: string): Map<string, SnackBarItem> {
    putSnackBarItem(this.snackBarsMap, msg, 'info');
    return new Map<string, SnackBarItem>(this.snackBarsMap);
  }
  @Action({ commit: 'setSnackbarItem' })
  public addSuccessMessage(msg: string): Map<string, SnackBarItem> {
    putSnackBarItem(this.snackBarsMap, msg, 'success');
    return new Map<string, SnackBarItem>(this.snackBarsMap);
  }
  @Action({ commit: 'setSnackbarItem' })
  public hideMessage(id: string) {
    this.snackBarsMap.get(id)!.show = false;
    return new Map<string, SnackBarItem>(this.snackBarsMap);
  }
  @Action({ commit: 'setSnackbarItem' })
  public clearMessage() {
    return new Map<string, SnackBarItem>();
  }
  @Mutation
  public setSnackbarItem(payload: Map<string, SnackBarItem>) {
    this.snackBarsMap = payload;
  }
  public get snackBars(): Array<SnackBarItem> {
    const array = new Array<SnackBarItem>();
    this.snackBarsMap.forEach(v => {
      array.push(v);
    });
    return array;
  }

  // ローダー表示管理
  @Action({ commit: 'setLoader' })
  public showLoader() {
    return { loader: true };
  }
  @Action({ commit: 'setLoader' })
  public hideLoader() {
    return { loader: false };
  }
  @Mutation
  public setLoader(payload: LoaderStatus) {
    this.loader = payload.loader;
  }
}
/**
 * SnackBarに表示するメッセージを追加する
 * @param map メッセージマップ
 * @param msg 表示メッセージ
 * @param color SnackBarの色
 */
const putSnackBarItem = (
  map: Map<string, SnackBarItem>,
  msg: string,
  color: string
) => {
  const id = `${new Date().getTime()}-${Math.floor(
    Math.random() * 10000000000
  )}`;
  map.set(id, {
    id: id,
    text: msg,
    color: color,
    show: true
  });
};

export default getModule(StoreModule);
